export default {
    name: 'numberFormat',
    bind: function(el, binding) {
        const re = /\d/;
        el.dsHandler = function(e) {
            e = e || window.event;
            const charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
            if(binding.modifiers.float) {
                if(charcode == 46) {
                    if(el.value && el.value.includes('.')) {
                        e.preventDefault();
                    }
                    return;
                }else if(binding.arg == "negativeMoney" && charcode == 45) {
                    if(el.value && el.value.includes('.')) {
                        e.preventDefault();
                    }
                    return;
                }
            }
            if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
                if(e.preventDefault) {
                    e.preventDefault();
                }else {
                    e.returnValue = false;
                }
            }
        };
        el.addEventListener("keypress", el.dsHandler);
    },
    update: function(el, binding) {
        // 可以为负数
        if(binding.arg == "negativeMoney") {
            const re = /\d/;
            let value = binding.value.money;
            if(value == '' || value == null) {
                return;
            }
            if((re.test(value) && value != null) || value.includes('-')) {
                if(typeof value == "number") {
                    value = value.toString();
                }
                if(value.includes('.')) {
                    const temp = value.split('.');
                    if(temp.length >= 2) {
                        if(binding.arg == 'rebateRatio') {
                            binding.value.money = Number(parseInt(value)).toString().slice(0, 8) + "." + temp[1].slice(0, 4);
                        }else {
                            binding.value.money = temp[0] + "." + temp[1].slice(0, 2);
                        }
                    }else {
                        binding.value.money = temp[0];
                    }
                }else {
                    const temp = value.toString().match(/(^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$)/g);
                    if(Array.isArray(temp) && temp.length > 0) {
                        if(value == '-00') {
                            binding.value.money = '-0';
                            return;
                        }else if(value.slice(0, 2) == '-0') {
                            binding.value.money = value.slice(0, 2);
                            return;
                        }
                        binding.value.money = temp[0];
                    }else {
                        if(value == '-') {
                            binding.value.money = '-';
                        }else {
                            if(value == '--') {
                                binding.value.money = '-';
                                return;
                            }
                            binding.value.money = null;
                        }
                    }
                }
            }else {
                binding.value.money = null;
            }
            return;
        }


        const re = /\d/;
        let value = binding.value[binding.arg];
        if(re.test(value) && value != null) {
            if(typeof value == "number") {
                value = value.toString();
            }
            if(value.includes('.')) {
                const temp = value.split('.');
                if(temp.length >= 2) {
                    if(binding.arg == 'rebateRatio') {
                        binding.value[binding.arg] = Number(parseInt(value)).toString().slice(0, 8) + "." + temp[1].slice(0, 4);
                    }else {
                        binding.value[binding.arg] = Number(parseInt(value)).toString().slice(0, 8) + "." + temp[1].slice(0, 2);
                    }
                }else {
                    binding.value[binding.arg] = temp[0];
                }
            }else {
                const temp = Number(parseInt(value)).toString().match(/^[0-9]{1}\d{0,7}/g);
                if(Array.isArray(temp) && temp.length > 0) {
                    binding.value[binding.arg] = temp[0];
                }else {
                    binding.value[binding.arg] = null;
                }
            }
        }else {
            binding.value[binding.arg] = null;
        }
    },
    unbind: function(el) {
        el.removeEventListener("keypress", el.dsHandler);
    }
};
